import { memo } from 'react';
import { CompositeSegment } from '@goldcast/player-config/src/types/RemotionPlayerConfigTypes/Segment/CompositeSegment';
import TimelineSpeaker from './TimelineSpeaker';
import { useClipsContext } from '@/context/ClipsContext/ClipsContext';
import { useTimelineSpeakers } from '@/hooks/useTimelineSpeakers';

function TimelineSpeakers({
  compositeSegmentDragStart,
  compositeSegmentDragEnd,
  compositeSegment
}: {
  compositeSegmentDragStart: number;
  compositeSegmentDragEnd: number;
  compositeSegment: CompositeSegment;
}) {
  const { fps } = useClipsContext();
  const { speakers, screenShareSpeakerDetails, sharedVideoTrackDetails } = useTimelineSpeakers();

  return (
    <div className="flex flex-col gap-1">
      {speakers.map(speaker => (
        <TimelineSpeaker
          key={speaker.key}
          speaker={speaker}
          speakerCount={speakers.length}
          compositeSegmentDragStart={compositeSegmentDragStart}
          compositeSegmentDragEnd={compositeSegmentDragEnd}
          compositeSegment={compositeSegment}
          fps={fps}
        />
      ))}
      {screenShareSpeakerDetails && (
        <TimelineSpeaker
          key={screenShareSpeakerDetails.id}
          speaker={screenShareSpeakerDetails}
          speakerCount={speakers.length}
          compositeSegmentDragStart={compositeSegmentDragStart}
          compositeSegmentDragEnd={compositeSegmentDragEnd}
          compositeSegment={compositeSegment}
          fps={fps}
        />
      )}
      {sharedVideoTrackDetails && (
        <TimelineSpeaker
          key={sharedVideoTrackDetails.id}
          speaker={sharedVideoTrackDetails}
          speakerCount={speakers.length}
          compositeSegmentDragStart={compositeSegmentDragStart}
          compositeSegmentDragEnd={compositeSegmentDragEnd}
          compositeSegment={compositeSegment}
          fps={fps}
        />
      )}
    </div>
  );
}

export default memo(TimelineSpeakers);
